/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS202: Simplify dynamic range loops
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
$(function() {
  root.CountUpdater = class CountUpdater {
    constructor(input) {
      $(input).on("change", function(e) {
        const element = $(input).closest("form")
        return Rails.fire(element[0], 'submit');
      });
    }
  };

  root.StaffEditingTable = class StaffEditingTable {
    constructor() {
      this.edit_staff_link = $("a.edit_staff_link");
      this.save_staff_link = $("a#save_staff_link");

      if (this.edit_staff_link.data("initialized") === true) { return; }
      this.edit_staff_link.data("initialized", true);

      this.edit_staff_link.on("click", function(e) {
        $("#edit-staff").slideToggle();
        return e.preventDefault();
      });

      this.save_staff_link.on("click", function(e) {
        $("#edit-staff").slideUp();
        return e.preventDefault();
      });
    }
  };

  root.PositionFormAutoSaver = class PositionFormAutoSaver {
    constructor() {
      $("#new_position select").on("change", function(e) {
        const element = $(this).closest("form")
        return Rails.fire(element[0], 'submit');
      });
    }
  };


  // this counter uses span.count in first row or column and picks values
  // from input of type number within table to draw totals.
  root.TeamTableTotalCounter = class TeamTableTotalCounter {
    constructor() {
      this.setupInitialState = this.setupInitialState.bind(this);
      this.addCountsInRows = this.addCountsInRows.bind(this);
      this.addCountsInColumns = this.addCountsInColumns.bind(this);
      this.getCountInSingleColumn = this.getCountInSingleColumn.bind(this);
      this.pageHasTable = this.pageHasTable.bind(this);
      this.table = $("#countable_table");
      if (!this.pageHasTable()) { return; }

      $(document).on("count:table", () => {
        this.addCountsInRows();
        return this.addCountsInColumns();
      });

      this.setupInitialState();
    }

    setupInitialState() {
      return $(document).trigger("count:table");
    }

    addCountsInRows() {
      const row_length = this.table.get(0).rows.length;
      return __range__(1, (row_length), true).map((index) =>
        (index => {
          let total_per_row = 0;
          for (let input of Array.from($(this.table.get(0).rows[index]).find("input[type='number']"))) { total_per_row += parseInt($(input).val()); }
          return $(this.table.get(0).rows[index]).find("span.count").html(`(${total_per_row})`);
        })(index));
    }

    addCountsInColumns() {
      const first_row = $(this.table.get(0).rows[0]);
      return $(first_row).children().each(index => {
        if (index === 0) { return; }
        return $($(first_row).children().get(index)).find("span.count").html(`(${this.getCountInSingleColumn(index)})`);
      });
    }

    getCountInSingleColumn(column_index) {
      const row_length = this.table.get(0).rows.length;
      let column_total = 0;
      for (let row_index = 1, end = row_length - 1, asc = 1 <= end; asc ? row_index <= end : row_index >= end; asc ? row_index++ : row_index--) { // ignore last row
        (row_index => {
          const value = $($(this.table.get(0).rows[row_index]).children().get(column_index)).find("input[type='number']:enabled").val();
          if (value != null) { return column_total += parseInt(value); }
        })(row_index);
      }
      return column_total;
    }

    pageHasTable() {
      return this.table.length >= 1; // ensures no JS errors
    }
  };

  root.teamTableSetup = function() {
    $("input.count_update").each(function(index) {
      return new root.CountUpdater(this);
    });
    new root.PositionFormAutoSaver;
    new root.StaffEditingTable;
    return new root.TeamTableTotalCounter;
  };

  return root.teamTableSetup();
});

function __range__(left, right, inclusive) {
  let range = [];
  let ascending = left < right;
  let end = !inclusive ? right : ascending ? right + 1 : right - 1;
  for (let i = left; ascending ? i < end : i > end; ascending ? i++ : i--) {
    range.push(i);
  }
  return range;
}
